import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "number" }
const _hoisted_3 = { class: "subtitle" }


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberedList',
  props: {
    items: {},
    color: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, {
    class: "common-numbered-list",
    lines: "three",
    "bg-color": "transparent",
    "base-color": "#F9F9F9"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock(_component_v_list_item, {
          key: index,
          title: item.title,
          subtitle: item.subtitle,
          class: "common-numbered-list-item"
        }, {
          title: _withCtx(({ title }) => [
            _createElementVNode("p", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(index + 1), 1),
              _createTextVNode(_toDisplayString(title), 1)
            ])
          ]),
          subtitle: _withCtx(({ subtitle }) => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(subtitle), 1)
          ]),
          _: 2
        }, 1032, ["title", "subtitle"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})